import { jsx } from 'react/jsx-runtime';
import { Badge as Badge$1 } from './Badge.styles.mjs';
"use strict";
const Badge = ({
  className,
  variant,
  children
}) => {
  return /* @__PURE__ */jsx(Badge$1, {
    $variant: variant,
    className,
    children
  });
};
export { Badge };
//# sourceMappingURL=Badge.mjs.map
